export default __webpack_public_path__ + "static/media/google.19c2bfdb.png";